<template>
	<div class="timeline">
		<div class="timeline__title">{{ title }}</div>
		<div class="timeline__legend">
			<SvgIcon icon="asterisk" color="gold" />{{ legend }}
		</div>
		<ul class="timeline__items">
			<TimelineItem
				v-for="item in timelineItems"
				:key="item.id"
				:fields="item.fields"
				class="timeline__item"
			/>
		</ul>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const title = computed(() => props.fields?.title?.value);
const legend = computed(() => props.fields?.legend?.value);
const timelineItems = computed(() => props.fields?.timelineItems);
</script>

<style lang="scss">
.timeline {
	margin: 0 16px;

	.timeline__title {
		color: var(--color-white, #fff);
		font-size: var(--text-2xl, 32px);
		font-weight: 900;
		line-height: 120%;
		text-transform: uppercase;
		margin-bottom: 20px;
	}

	.timeline__legend {
		color: #989898;
		font-size: var(--text-2xs, 10px);
		font-weight: 300;
		line-height: 128%;
		display: flex;
		align-items: center;
		gap: var(--spacing-1, 8px);
		margin-bottom: var(--spacing-3, 24px);
	}

	.timeline__items {
		display: flex;
		flex-direction: column;
		list-style: none;
		padding-left: 6px;
	}
}
</style>
